import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepAppsureBankDetails = (state) => state.get('stepAppsureBankDetails');

const makeSelectStepAppsureBankDetails = () =>
  createSelector(selectStepAppsureBankDetails, (stepAppsureBankDetailsState) => ({
    abn: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'abn']),
      ''
    ),
    claimITC: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'claimITC']),
      ''
    ),
    nameOfBank: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'nameOfBank']),
      ''
    ),
    branch: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'branch']),
      ''
    ),
    bsbNumber: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bsbNumber']),
      ''
    ),
    institutionNumber: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'institutionNumber']),
      ''
    ),
    accountNumber: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'accountNumber']),
      ''
    ),
    accountHolder: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'accountHolder']),
      ''
    ),
    registerForGSTPurpose: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'registerForGSTPurpose']),
      ''
    ),
    percentageOfGST: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'percentageOfGST']),
      ''
    ),
    bsbCannotBeVerified: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bsbCannotBeVerified']),
      ''
    ),
    isBsbValid: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'isBsbValid']),
      ''
    ),
    otherInsurance: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'otherInsurance']),
      ''
    ),
    provideDetails: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'provideDetails']),
      ''
    ),
    // V2 fields
    paymentTo: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'paymentTo']),
      'Member'
    ),
    country: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'country']),
      null
    ),
    isCheckPayment: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'isCheckPayment']),
      false
    ),
    paymentVia: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'paymentVia']),
      'EFT'
    ),
    bankTypeCode: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bankTypeCode']),
      ''
    ),
    bankCodeOrRoutingNumber: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bankCodeOrRoutingNumber']),
      ''
    ),
    bank: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bank']),
      ''
    ),
    bankAddress: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bankAddress']),
      ''
    ),
    bankSuburbOrCity: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bankSuburbOrCity']),
      ''
    ),
    bankPostcode: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bankPostcode']),
      ''
    ),
    bankBranch: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bankBranch']),
      ''
    ),
    bankAccountName: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bankAccountName']),
      ''
    ),
    bankAccountNumber: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'bankAccountNumber']),
      ''
    ),
    swiftCode: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'swiftCode']),
      ''
    ),
    iban: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'iban']),
      ''
    ),
    paymentTypeOptions: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'paymentTypeOptions']),
      []
    ),
    isValidate: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'isValidate']),
      false
    ),
    title: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'title']),
      ''
    ),
    firstName: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'firstName']),
      ''
    ),
    lastName: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'lastName']),
      ''
    ),
    addressLine1: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'addressLine1']),
      ''
    ),
    addressLine2: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'addressLine2']),
      ''
    ),
    state: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'state']),
      ''
    ),
    city: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'city']),
      ''
    ),
    postalZipCode: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'postalZipCode']),
      ''
    ),
    mobile: mapWithDefault(
      stepAppsureBankDetailsState,
      () => stepAppsureBankDetailsState.getIn(['form', 'mobile']),
      ''
    ),
  }));

const makeSelectStepAppsureBankDetailsErrors = () =>
  createSelector(selectStepAppsureBankDetails, (stepAppsureBankDetailsState) =>
    mapWithDefault(stepAppsureBankDetailsState, () => stepAppsureBankDetailsState.get('currentStep'), [])
  );

const makeSelectBsbValidating = () =>
  createSelector(selectStepAppsureBankDetails, (stepAppsureBankDetailsState) =>
    mapWithDefault(stepAppsureBankDetailsState, () => stepAppsureBankDetailsState.get('bsbValidating'), false)
  );

const makeSelectBsbNotice = () =>
  createSelector(selectStepAppsureBankDetails, (stepAppsureBankDetailsState) =>
    mapWithDefault(stepAppsureBankDetailsState, () => stepAppsureBankDetailsState.get('showBSBNotice'), false)
  );

export {
  makeSelectStepAppsureBankDetails,
  makeSelectStepAppsureBankDetailsErrors,
  makeSelectBsbValidating,
  makeSelectBsbNotice,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/selectors.js